import Quill from 'quill';
import {
    FONT_FAMILY_WHITE_LIST
} from '../quill.const';

/** HACK this fixes an issue where package builds think that these are node packages to import, rather than quill extensions */
const quimport = Quill.import.bind(Quill);
const PARCHMENT = quimport('parchment');

const CONFIG = {
    scope: PARCHMENT.Scope.INLINE,
    whitelist: FONT_FAMILY_WHITE_LIST
};

/**
 * Custom implementation of a Parchment style attribute.  Created to handle font family attribute
 */
export class CustomFontStyleAttribute extends PARCHMENT.Attributor.Style {
    keyName;
    canAdd;
    whitelist;

    constructor(attrName: string, keyName: string, options: any = {}) {
        super(attrName, keyName, options);
    }

    value(node) {
        const value = node.style[camelize(this.keyName)];

        if (!value) {
            return '';
        }

        const compareValue = value.replace(/['"]/g, '');
        const whiteListedFont = this.whitelist.find(font => {
            return font === compareValue;
        });

        if (whiteListedFont) {
            return whiteListedFont;
        }

        return this.canAdd(node, value) ? value : '';
    }
}


export const CUSTOM_FONT_STYLE = new CustomFontStyleAttribute('font', 'font-family', CONFIG);
export const FONT_CLASS = new PARCHMENT.Attributor.Class('font', 'ql-font', CONFIG);
Quill.register(CUSTOM_FONT_STYLE, true);
Quill.register(FONT_CLASS, true);

function camelize(name: string): string {
    const parts = name.split('-');
    const rest = parts
        .slice(1)
        .map(function (part: string) {
            return part[0].toUpperCase() + part.slice(1);
        })
        .join('');
    return parts[0] + rest;
}
